import { twJoin } from 'tailwind-merge';

export const SIZES = {
  '20': twJoin('size-5'),
};
